import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'white',
  },
  ctaBoxWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(12),
  },
  ctaBoxContainer: {
    display: 'flex',
    gap: `${theme.spacing(2)}px`,
    [theme.breakpoints.up('md')]: {
      gap: `${theme.spacing(4)}px`,
    },
  },
  ctaBox: {
    flex: '1 0 100%',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      flex: ({ multiple }) => multiple && `0 0 calc(50% - ${theme.spacing(2)}px)`,
    },
  },
}))

export default useStyles
